<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
             
              <b-button
                variant="primary"
                href="https://admin.ordredespharmaciens.sn/api/v1/dashboard/export-liste-pharmacien"
                target="_blank"
                download
              > 
                <span class="text-nowrap">Exporter</span>
              </b-button>

            </div>
          </b-col>
        </b-row>

      </div>
      <b-table
        ref="refPharmacienListTable"
        class="position-relative"
        :items="fetchListPharmacien"
        responsive 
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(fullName)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-primary`"
                
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <!-- <small class="text-muted">@{{ data.item.username }}</small> -->
          </b-media>
        </template>

       

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolvePharmacienStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item v-if="data.item.isBlockBtn" @click="activeAccount(data.item.id)">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Activer</span>
            </b-dropdown-item>

            <b-dropdown-item  v-if="!data.item.isBlockBtn" @click="desactiveAccount(data.item.id)">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Désactiver</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="!data.item.isBlockBtn" :to="{ name: 'configuration', params: { userData: data.item } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Bloquer</span>
            </b-dropdown-item>

            <!-- <b-dropdown-item :to="{ name: 'roles', params: { userData: data.item } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Gestion des rôles</span>
            </b-dropdown-item> -->

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
      
        <template #code>
        {{ codeConfirm }}
      </template>
    
    </b-card>
    
  </div>
  
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import usePharmaciensList from './usePharmaciensList'
import pharmaciensStoreModule from './pharmaciensStoreModule'

import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import Ripple from 'vue-ripple-directive'
// import UserListAddNew from './UserListAddNew.vue'
// import { codeConfirm } from '../extensions/code'

import axios from 'axios'

export default {
  components: {
    // UsersListFilters,
    // UserListAddNew,
    // codeConfirm,
    BCardCode,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {
    const PHARCMACIEN_APP_STORE_MODULE_NAME = 'app-pharmacien'

    // Register module
    if (!store.hasModule(PHARCMACIEN_APP_STORE_MODULE_NAME)) store.registerModule(PHARCMACIEN_APP_STORE_MODULE_NAME, pharmaciensStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PHARCMACIEN_APP_STORE_MODULE_NAME)) store.unregisterModule(PHARCMACIEN_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

  const pharmaciensOptions = [
      { id: 1, nom: 'Gaye', prenom: 'Cheikh', email: 'Cheikh@gmail.com', phone: '778889900', status: 'actif' , type_pharmacien: 'B/Pharmacien titulaire, remplaçant ou pharmacien gérant d’officine'},
      { id: 2, nom: 'Lebrun', prenom: 'Loic', email: 'loic@lebrun.com', phone: '776665544', status: 'inactif' , type_pharmacien: 'PUBLIC_SECRETAIRE'},
    ]

  

    const {

      fetchListPharmacien,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPharmacienListTable,
      refetchData,

      // UI
      // resolveUserRoleVariant,
      // resolveUserRoleIcon,
      resolvePharmacienStatusVariant,

    } = usePharmaciensList()
 
    return {

      // Sidebar
      isAddNewUserSidebarActive,
      fetchListPharmacien,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPharmacienListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      // resolveUserRoleVariant,
      // resolveUserRoleIcon,
      resolvePharmacienStatusVariant,


      pharmaciensOptions

    }
  },
  methods: {

    // confirmAlert() { 
    //    this.$swal({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes, delete it!',
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //       cancelButton: 'btn btn-outline-danger ml-1',
    //     },
    //     buttonsStyling: false,
    //   }).then(result => {
    //     if (result.value) {
    //       this.$swal({
    //         icon: 'success',
    //         title: 'Deleted!',
    //         text: 'Your file has been deleted.',
    //         customClass: {
    //           confirmButton: 'btn btn-success',
    //         },
    //       })
    //     }
    //   })
    // },
    activeAccount(id) {
       try {
        axios
          .get('https://admin.ordredespharmaciens.sn/api/v1/dashboard/active-account/' + id)
          .then(() => {
            window.location.reload()
          })
      } catch (error) {
        console.log("error", error);
      }
      
    },
    desactiveAccount(id) {
       try {
        axios
          .get('https://admin.ordredespharmaciens.sn/api/v1/dashboard/desactive-account/' + id)
          .then(() => {
            window.location.reload()
          })
      } catch (error) {
        console.log("error", error);
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';

</style>
